import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "dropdownArrow",
  "use": "dropdownArrow-usage",
  "viewBox": "0 0 10 5",
  "content": "<symbol viewBox=\"0 0 10 5\" id=\"dropdownArrow\"><title>BD2A47F8-E6E7-4CA8-80FC-C6C60D6AA271</title><path d=\"M10 0L5 5 0 0z\" fill=\"#9B9B9B\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/components/units/Icon/icons/dropdownArrow.svg
// module id = 509
// module chunks = 1